import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { Layout } from 'antd';
import Sidebar from './components/sidebar.jsx';
import Top from './components/top.jsx';
import Main from './components/main.jsx';
import utils from '@/utils/auth';

class LayoutPage extends Component {
  render() {
    if (!utils.isLoginStatus()) return <Redirect to="/login" />;
    return (
      <Layout>
       <Sidebar />
        <Layout>
          <Top />
          <Main />
        </Layout>
      </Layout>
    );
  }
}

export default withRouter(LayoutPage);
